<template>
    <div class="createOtherActive">
        <el-form ref="form" :model="form" label-width="132px" :rules="rules" label-position="left">
            <div class="contentBox">
                <div class="topBox">
                    <div class="title">基本信息</div>
                </div>
                <div class="itemBox">
                    <el-form-item label="活动标题" class="isRequire" prop="title">
                        <el-input v-model="form.title" placeholder="输入活动标题，不超过40个字" maxlength="40"></el-input>
                    </el-form-item>
                    <el-form-item label="活动链接" class="isRequire" prop="enrolllinkurl">
                        <el-input v-model="form.enrolllinkurl" placeholder="请填写活动链接" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="活动封面" class="isRequire" prop="coveratturlid">
                        <div class="upload">
                            <div class="imgBox">
                                <img class="icon" v-if="!form.coveratturlid.furl" :src="require('@/common/images/other/icon_default_image@2x.png')" alt="">
                                <img v-else class="activityCoverImage" :src="form.coveratturlid.furl + '?' + time" alt="">
                            </div>
                            <div class="uploadBtnBox">
                                <el-button @click.native="openDialog">选择文件</el-button>
                                <p class="tips">建议尺寸750*420px的JPG、PNG格式， 图片小于2M。</p>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="活动城市" class="isRequire" prop="enrollcityname">
                        <el-select v-model="form.enrollcityname" placeholder="请选择">
                            <el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <!-- <el-cascader placeholder="请选择活动城市" :options="citysList" @change="selectedCity" ref="myCascader"  v-model="currentCity"></el-cascader> -->
                    </el-form-item>
                    <el-form-item label="活动时间段" class="isRequire time" prop="date">
                        <!-- <el-date-picker v-model="form.date" type="datetimerange" range-separator="至" start-placeholder="活动开始时间" end-placeholder="活动结束时间"></el-date-picker> -->
                        <el-date-picker v-model="form.begintime" value-format="yyyy-MM-dd HH:mm:ss" :disabled="activeStatus" type="datetime" placeholder="选择活动开始时间"></el-date-picker>
                        <span class="to">至</span>
                        <el-date-picker v-model="form.endtime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择活动结束时间"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="btnBox">
                <el-button @click="$router.back()">取消</el-button>
                <el-button type="primary" @click="saveEnrolleventinfo">确定</el-button>
            </div>
        </el-form>
        <!-- 裁图 -->
        <ShopLocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage" :uploadType="uploadType"></ShopLocalCropper>
    </div>
</template>
<script>
import citys from 'common/js/citys.json'
import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import {saveEnrolleventinfoV2, getEnrolleventinfoDetailV2} from 'api/activeApi'
import { mapActions} from 'vuex' // 引入 vuex 组件
export default {
    name: 'CreateOtherActive',
    data() {
        let checkdate = (rule, value, callback) => {
            let now = new Date().getTime()
            if (!this.form.begintime || !this.form.endtime) {
                if (!this.form.begintime) {
                    callback('请选择活动开始时间')
                } else if (!this.form.endtime) {
                    callback('请选择活动结束时间')
                }
            } else if (new Date(this.form.endtime).getTime() === new Date(this.form.begintime).getTime() || new Date(this.form.endtime).getTime() < new Date(this.form.begintime).getTime()) {
                callback('活动开始时间不能小于等于结束时间')
            } else {
                callback()
            }
        }
        let checkCity = (rule, value, callback) => {
            if (this.form.enrollcityname) {
                callback()
            } else {
                callback('请选择活动城市')
            }
        }
        return {
            cityOptions: [
                {value: '北京', label: '北京'},
                {value: '上海', label: '上海'},
                {value: '广州', label: '广州'},
                {value: '深圳', label: '深圳'},
                {value: '杭州', label: '杭州'},
                {value: '武汉', label: '武汉'},
                {value: '成都', label: '成都'},
                {value: '长沙', label: '长沙'},
                {value: '南京', label: '南京'},
                {value: '重庆', label: '重庆'},
                {value: '苏州', label: '苏州'},
                {value: '其他', label: '其他'},
            ],
            citysList: citys,
            currentCity: '',
            activeStatus: false,
            rules: {
                title: [
                    { required: true, message: '请输入活动标题', trigger: 'blur' }
                ],
                coveratturlid: [
                    { required: true, message: '请选择活动封面', trigger: 'blur' }
                ],
                date: [
                    {validator: checkdate, trigger: 'blur'}
                ],
                enrolllinkurl: [
                    { required: true, message: '请输入活动链接', trigger: 'blur' }
                ],
                enrollcityname: [
                    { required: true, message: '请选择活动城市', trigger: 'blur' }
                ]
            },
            time: new Date().getTime(),
            form: {
                title: '',
                begintime: '',
                endtime: '',
                enrolllinkurl: '',
                enrollcityname: '',
                coveratturlid: '',
                eventinnerid: ''
            },
            cropperOption: {
                fixedNumber: [750, 420], // 截图框的宽高比例
                enlarge: 4.4, // 图片根据截图框输出比例倍数
                autoCropWidth: 170, // 默认生成截图框宽度
                autoCropHeight: 100 // 默认生成截图框高度
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
        }
    },
    created() {
        if (this.$route.query.eventinnerid) {
            this.getEnrolleventinfoDetailV2()
        }
    },
    methods: {
        getEnrolleventinfoDetailV2() {
            this.setLoading(true)
            let options = {
                eventinnerid: this.$route.query.eventinnerid
            }
            getEnrolleventinfoDetailV2({
                data: options,
                success: res => {
                    this.setLoading(false)
                    this.form = res.data
                    let time = new Date().getTime()
                    if (time > new Date(this.form.begintime).getTime() && this.$route.query.title !== 'copy') {
                        this.activeStatus = true
                    }
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        openDialog() {
            this.$refs.localCropper.openDialog()
        },
        selectedCity(city) {
            console.log(city)
            // this.item.proviceid = city[0]
            // this.item.cityid = city[1]
            // this.item.countid = city[2]
            let nameList = this.$refs.myCascader.getCheckedNodes()[0].pathLabels
            this.form.enrollcityname = nameList[0]+' '+nameList[1]+' '+nameList[2]
            console.log(this.currentCity)
            // this.item.provicename = nameList[0]
            // this.item.cityname = nameList[1]
            // this.item.countname = nameList[2]
        },
        // 设置图片信息（本地）
        _setImage(img) {
            // 发生头像图片变更操作
            this.updateImgStatus = true
            // $("input[name=headerimg]:checked").prop('checked',false)    // 清除选中头像
            // console.log(img)
            this.time = new Date().getTime()

            this.form.coveratturlid = img
            // this.form.logodata = img

            //  this.$refs.coverfile.setImage( this.starMgtForm.logodata.furl)

            // 设置图片
            // $this.$refs.coverfile.setImage($this.form.starlogourl)
        },
        saveEnrolleventinfo() {
            this.$refs.form.validate((valid, name) => {
                if (valid) {
                    this.setLoading(true)
                    console.log(this.form)
                    let coveratturlid = this.form.coveratturlid
                    delete coveratturlid.type
                    let options = {
                        title: this.form.title,
                        begintime: this.form.begintime,
                        endtime: this.form.endtime,
                        enrolllinkurl: this.form.enrolllinkurl,
                        enrollcityname: this.form.enrollcityname,
                        coveratturlid: JSON.stringify(coveratturlid),
                        eventinnerid: this.$route.query.title === 'copy' ? '' : this.form.eventinnerid
                    }
                    saveEnrolleventinfoV2({
                        data: options,
                        success: res => {
                            this.setLoading(false)
                            this.$message.success('保存成功')
                            let that = this
                            setTimeout(function() {
                                that.$router.back(-1)
                            }, 500)
                            console.log(res)
                        },
                        error: res => {
                            this.setLoading(false)
                            this.$message.error(res.msg)
                        }
                    })
                } else {
                    console.log(name)
                    for(let key  in name){
                        this.$message.error(name[key][0].message)
                        return false
                    }
                    return false
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        ShopLocalCropper
    }
}
</script>
<style lang="scss">
    .createOtherActive {
        height: 100%;

        .topBox {
            padding: 20px;
            border-bottom: 1px solid #DCDFE6;
            .title {
                font-size: 16px;
                line-height: 20px;
                font-weight: bold;
                padding-left: 8px;
                border-left: 2px solid #409EFF;
            }
        }
        .el-form {
            // padding: 20px 30px;
            height: 100%;
            display: flex;
            flex-direction: column;
            .contentBox {
                background: #fff;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
                flex: 1;
            }
            .itemBox {
                padding: 20px 30px;
            }
            .el-input {
                width: 400px;
            }
            .el-date-editor {
                .el-input__icon, .el-range-separator {
                    line-height: 24px;
                }
            }
            .el-select {
                .el-select__caret {
                    line-height: 32px;
                }
            }
            .upload {
                display: flex;
                align-items: center;
                .imgBox {
                    width: 318px;
                    height: 178px;
                    background: #F5F7FA;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 12px;
                    .icon {
                        width: 100px;
                        height: 100px;
                    }
                    .activityCoverImage {
                        width: 318px;
                        height: 178px;
                    }
                }
                .uploadBtnBox {
                    .tips {
                        font-size: 14px;
                        color: #909399;
                    }
                }
            }
            .isRequire {
                .el-form-item__label::before {
                    content: '';
                }
                .el-form-item__label::after {
                    content: '*';
                    color: #F56C6C;
                    margin-left: 4px;
                }
            }
            .time {
                .to {
                    margin: 0 10px;
                }
                .el-date-editor {
                    width: 200px;
                }
            }
        }
        .btnBox {
            background: #fff;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
            margin-top: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px;
        }
    }
</style>
